export const sportsOptions = [
    { label: 'Basketball', value: 'basketball' },
    { label: 'Football', value: 'football' },
    { label: 'Soccer', value: 'soccer', isComingSoon: true },
    { label: 'Volleyball', value: 'volleyball', isComingSoon: true },
    { label: 'Tennis', value: 'tennis', isComingSoon: true },
    { label: 'Baseball', value: 'baseball', isComingSoon: true },
  ];  